<template>
  <th>
    <slot/>
  </th>
</template>

<script>
export default {
  name: 'BaseAdminTableColumn',
  inject: ['selectable'],
};
</script>

<style scoped>

</style>
